import React, { useContext } from 'react';
import PropTypes from '@squiz/xaccel-prop-types';
import { generateClasses } from '@squiz/xaccel-utility-functions';
import AssistedInputContext from './AssistedInputContext';
import styles from '../css/global.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
function AssistedInputResultsContainer(_ref) {
  let {
    children,
    className,
    ...restProps
  } = _ref;
  const {
    id,
    assistActive
  } = useContext(AssistedInputContext);
  return /*#__PURE__*/_jsx("div", {
    id: `assisted-input-results-grid-${id}`,
    role: "grid",
    "aria-labelledby": `assisted-input-label-${id}`,
    "aria-hidden": !assistActive,
    tabIndex: -1,
    className: generateClasses({
      block: 'assisted-input-results',
      override: className
    }, styles),
    ...restProps,
    children: children
  });
}
AssistedInputResultsContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.classNameOverride
};
AssistedInputResultsContainer.defaultProps = {
  children: undefined,
  className: undefined
};
export default AssistedInputResultsContainer;